import React from 'react';
import {BrowserRouter as Router, Route, Switch, NavLink, withRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from './store';
import {Layout, Menu, Icon} from 'antd';

import UaList from './containers/sider/user-angent';
import DeviceList from './containers/sider/device';
import LocalResourceList from './containers/sider/localResource';
import TecentConfigList from './containers/sider/tecentConfig';
import StandardLineList from './containers/sider/standardLine';

import OutTaskCategoryList from './containers/sider/outTaskCategory';
import BrowserList from './containers/sider/browser';
import BaselineList from './containers/sider/baseline';
import HostList from './pages/assist/hostManage/index';
import DeviceIndex from './pages/assist/deviceIndex/index';
import LogCollect from './pages/assist/logCollect/index';
import TaskStatistics from './pages/StatisticalAnalysis/task-statistics/index';
import PartnerStatistics from './containers/sider/partner-statistics';
import IPStatistics from './containers/sider/ip-statistics';
import VPS from './containers/sider/vps';
import VpsMonitor from './containers/sider/vpsmonitor';
import ServerMonitor from './containers/sider/servermonitor';
import OperatingMonitor from './pages/monitor/operating/index';
import Partner from './containers/sider/partner';
import NotFound from './containers/sider/notfound';
import UserList from './containers/sider/userlist';
import UserEdit from './containers/sider/useredit';
import TaskMessage from './pages/user/taskMessage/index';
import TaskList from './pages/task/tasklist';
import todayStartTask from './pages/task/todayStartTask';
import UserGroup from './pages/user/userGroup/index';
import StatisticsView from './pages/StatisticalAnalysis/statistics-view/index';
import Report from './pages/StatisticalAnalysis/report/index';
import ExportData from './pages/StatisticalAnalysis/exportData/index';
import NewExportData from './pages/StatisticalAnalysis/newExportData/index';
import EverydayExecInfo from './pages/StatisticalAnalysis/everydayExecInfo/index';
import AgencyAnalysis from './pages/StatisticalAnalysis/agencyAnalysis/';
import AgentConnentData from './pages/StatisticalAnalysis/agentConnentData/';
import widthAndConnect from './pages/StatisticalAnalysis/widthAndConnect/';
import ProxyExecuteData from './pages/StatisticalAnalysis/proxyExecuteData/';
import taskVolume from './pages/StatisticalAnalysis/taskVolume/';
import phoneDetail from './pages/StatisticalAnalysis/phoneDetail/';
import advertPositionData from './pages/StatisticalAnalysis/advertPositionData/';
import advertPositionCurve from './pages/StatisticalAnalysis/advertPositionDataCurve';
import PrivateRoute from './pages/login/PrivateRoute';
import PrivateRouteNoLogin from './pages/login/PrivateRouteNoLogin.js';
import Logo from './pages/login/Logo';
import Login from './pages/login/index';
import Index from './pages/index/index';
import ClientList from './pages/client/clientList';
import CommendList from './pages/client/commendList';
import MachineCheck from './pages/client/machineCheck';
import ScriptList from './pages/client/scriptList';
import AppList from './pages/client/AppList';
import AccountList from './pages/client/AppAccount';
import wxAccountList from './pages/client/wxAccount';
import CertificateList from './pages/client/certificateList';
import AdvertPosition from './pages/client/advertPosition';
import FileList from './pages/fileList';
import DiscardList from './pages/monitor/discard';
import LocalResourceRate from './pages/monitor/localResourceRate';

import AgentManage from './pages/monitor/agent';
import signList from './pages/sign/signList';
import taskInfo from './pages/sign/taskInfo';
import thirdParty from './pages/monitor/thirdparty';
import clientManage from './pages/assist/clientManage';
import nameTest from './pages/monitor/name';
import taskExcuteData from './pages/monitor/taskExcuteData';
import taskIvt from './pages/monitor/taskIvt';
import taskNotes from './pages/sign/taskNotes';
import operationRecords from './pages/sign/operationRecords';

// import TaskStatistics from './containers/sider/task-statistics';
// import tasklist from './containers/sider/tasklist';

// const mapStateToProps = state => ({...(state.login.userInfo)});
// const token = localStorage.getItem('HippoUserInfo');

const {SubMenu} = Menu;
const {Header, Content, Footer, Sider} = Layout;
const user = localStorage.getItem('HippoUserInfo') ? JSON.parse(localStorage.getItem('HippoUserInfo')) : null;
const onCollapse = (collapsed, type) => {
    const rootDom = document.getElementById('root');
    if (collapsed == true) {
        rootDom.classList.add('large-layout');
    } else {
        rootDom.classList.remove('large-layout');
    }
};

const SideMenu = withRouter(class Sider extends React.Component {
    // submenu keys of first level
    rootSubmenuKeys = ['index', 'statistics', 'task', 'assist', 'partner', 'monitor', 'user'];
    state = {
        openKeys: [],
        selectKeys: [],
    };

    componentDidMount() {
        let {rootSubmenuKeys} = this;
        let {location} = this.props;
        let {pathname} = location;
        let {key} = location;
        let i = 0;
        try {
            rootSubmenuKeys.forEach(item => {
                if (pathname.indexOf(item) > -1) {
                    i++;
                    this.setState({
                        openKeys: [item],
                        selectKeys: [pathname],
                    });
                }
                if (i != 0) {
                    throw BreakException;
                }
            });
        } catch (e) {

        }
    }

    onOpenChange = openKeys => {
        console.log('openchange===');
        const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.setState({openKeys});
        } else {
            this.setState({
                openKeys: latestOpenKey ? [latestOpenKey] : [],
            });
        }
    };
    onSelected = item => {
        this.setState({
            selectKeys: item.selectedKeys,
        });
    }

    render() {
        return (
            <Menu
                mode="inline"
                // defaultSelectedKeys={['/index']}
                selectedKeys={this.state.selectKeys}
                defaultOpenKeys={this.state.openKeys}
                openKeys={this.state.openKeys}
                onOpenChange={this.onOpenChange}
                onSelect={this.onSelected}
                style={{height: '100%'}}>
                <Menu.Item key="/index">
                    <Icon type="home"/>
                    <span>首页</span>
                    <NavLink to="/index"/>
                </Menu.Item>
                <SubMenu
                    key="statistics"
                    title={
                        <span>
                            <Icon type="bar-chart"/>
                            <span>统计分析</span>
                        </span>
                    }>
                    <Menu.Item key="/statistics/task">
                        <NavLink to="/statistics/task">任务统计</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/taskView">
                        <NavLink to="/statistics/taskView">结算统计</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/report">
                        <NavLink to="/statistics/report">统计报表</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/exportData">
                        <NavLink to="/statistics/exportData">数据导出</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/newExportData">
                        <NavLink to="/statistics/newExportData">任务统计导出</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/everydayExecInfo">
                        <NavLink to="/statistics/everydayExecInfo">今日执行概括</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/agencyAnalysis">
                        <NavLink to="/statistics/agencyAnalysis">代理商分析</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/widthAndConnect">
                        <NavLink to="/statistics/widthAndConnect">代理商质量统计</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/agentConnentData">
                        <NavLink to="/statistics/agentConnentData">代理商并发分析</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/proxyExecuteData">
                        <NavLink to="/statistics/proxyExecuteData">代理执行数统计</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/taskVolume">
                        <NavLink to="/statistics/taskVolume">任务量统计</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/phoneDetail">
                        <NavLink to="/statistics/phoneDetail">广点通</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/advertPositionData">
                        <NavLink to="/statistics/advertPositionData">客户端运营数据</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/statistics/advertPositionCurve">
                        <NavLink to="/statistics/advertPositionCurve">客户端运营数据统计</NavLink>
                    </Menu.Item>
                    {/* <Menu.Item key="51"><NavLink to="/statistics/51">合作商统计</NavLink></Menu.Item>
                                    <Menu.Item key="52"><NavLink to="/statistics/52">供应商IP重叠统计</NavLink></Menu.Item> */}
                </SubMenu>
                <SubMenu
                    key="task"
                    title={
                        <span>
                            <Icon type="laptop"/>
                            <span>任务管理</span>
                        </span>
                    }>
                    <Menu.Item key="/task/tasklist">
                        <NavLink to="/task/tasklist">任务列表</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/task/todayStartTask">
                        <NavLink to="/task/todayStartTask">今日首次执行任务</NavLink>
                    </Menu.Item>
                </SubMenu>
                {user.role == 1 ? (
                    <SubMenu
                        key="assist"
                        title={
                            <span>
                                <Icon type="schedule"/>
                                <span>辅助信息</span>
                            </span>
                        }>
                        <Menu.Item key="/assist/40">
                            <NavLink to="/assist/40">UA信息管理</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/assist/41">
                            <NavLink to="/assist/41">设备管理</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/assist/42">
                            <NavLink to="/assist/42">浏览器管理</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/assist/hostManage">
                            <NavLink to="/assist/hostManage">主机管理</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/assist/tecentConfigManage">
                            <NavLink to="/assist/tecentConfigManage">主机配置管理</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/assist/clientManage">
                            <NavLink to="/assist/clientManage">客户端组管理</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/assist/outTaskCategoryManage">
                            <NavLink to="/assist/outTaskCategoryManage">外部任务分类管理</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/assist/localResourceManage">
                            <NavLink to="/assist/localResourceManage">素材数据管理</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/assist/standardLine">
                            <NavLink to="/assist/standardLine">曲线管理</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/assist/deviceIndex">
                            <NavLink to="/assist/deviceIndex">设备索引管理</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/assist/logCollect">
                            <NavLink to="/assist/logCollect">任务追踪管理</NavLink>
                        </Menu.Item>
                        {/* <Menu.Item key="43"><NavLink to="/assist/43">基准线数据管理</NavLink></Menu.Item> */}
                    </SubMenu>
                ) : null}
                {user.role == 1 ? (
                    <SubMenu
                        key="partner"
                        title={
                            <span>
                                <Icon type="team"/>
                                <span>合作商管理</span>
                            </span>
                        }>
                        <Menu.Item key="/partner/10">
                            <NavLink to="/partner/10">VPS</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/partner/11">
                            <NavLink to="/partner/11">合作商列表</NavLink>
                        </Menu.Item>
                    </SubMenu>
                ) : null}
                {user.role == 1 ? (
                    <SubMenu
                        key="monitor"
                        title={
                            <span>
                                <Icon type="eye-o"/>
                                <span>监控</span>
                            </span>
                        }>
                        <Menu.Item key="/monitor/localResourceRate">
                            <NavLink to="/monitor/localResourceRate">素材填充率监控</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/monitor/60">
                            <NavLink to="/monitor/60">服务监控</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/monitor/61">
                            <NavLink to="/monitor/61">VPS监控</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/monitor/62">
                            <NavLink to="/monitor/62">操作监控</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/monitor/discardList">
                            <NavLink to="/monitor/discardList">废弃监控</NavLink>
                        </Menu.Item>
                        {/*   <Menu.Item key="/monitor/agentManage">
                            <NavLink to="/monitor/agentManage">代理池宽度监控</NavLink>
                        </Menu.Item>*/}
                        <Menu.Item key="/monitoringcode/query">
                            <NavLink to="/monitoringcode/query">第三方公司代码</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/monitor/name">
                            <NavLink to="/monitor/name">任务监控</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/monitor/taskExcuteData">
                            <NavLink to="/monitor/taskExcuteData">任务执行数据</NavLink>
                        </Menu.Item>
                        <Menu.Item key="/monitor/taskIvt">
                            <NavLink to="/monitor/taskIvt">任务sivt</NavLink>
                        </Menu.Item>
                    </SubMenu>
                ) : null}

                <SubMenu
                    key="user"
                    title={
                        <span>
                            <Icon type="user"/>
                            <span>用户管理</span>
                        </span>
                    }>
                    {user.role == 1 ? (
                        <Menu.Item key="/user/list">
                            <NavLink to="/user/list">用户列表</NavLink>
                        </Menu.Item>
                    ) : null}

                    {user.role == 1 ? (
                        <Menu.Item key="/user/userGroup">
                            <NavLink to="/user/userGroup">用户群组列表</NavLink>
                        </Menu.Item>
                    ) : null}
                    {user.role == 1 ? (
                        <Menu.Item key="/user/taskMessage">
                            <NavLink to="/user/taskMessage">任务通知</NavLink>
                        </Menu.Item>
                    ) : null}
                    <Menu.Item key="/user/edit">
                        <NavLink to="/user/edit">修改密码</NavLink>
                    </Menu.Item>
                </SubMenu>
                <SubMenu
                    key="client"
                    title={
                        <span>
                            <Icon type="phone"/>
                            <span>客户端</span>
                        </span>
                    }>
                    <Menu.Item key="/client/clientList">
                        <NavLink to="/client/clientList">客户端列表</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/client/commend">
                        <NavLink to="/client/commend">下发命令列表</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/client/scriptList">
                        <NavLink to="/client/scriptList">脚本管理</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/client/AppList">
                        <NavLink to="/client/AppList">app管理</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/client/certificateList">
                        <NavLink to="/client/certificateList">证书管理</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/client/AccountList">
                        <NavLink to="/client/AccountList">账号管理</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/client/wxAccountList">
                        <NavLink to="/client/wxAccountList">公众号管理</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/client/advertPosition">
                        <NavLink to="/client/advertPosition">广告位管理</NavLink>
                    </Menu.Item>
                </SubMenu>
                <SubMenu
                    key="file"
                    title={
                        <span>
                            <Icon type="file"/>
                            <span>文件管理</span>
                        </span>
                    }>
                    <Menu.Item key="/file/fileList">
                        <NavLink to="/file/fileList">文件列表</NavLink>
                    </Menu.Item>
                </SubMenu>
                <SubMenu
                    key="signTask"
                    title={
                        <span>
                            <Icon type="check"/>
                            <span>签到</span>
                        </span>
                    }>
                    <Menu.Item key="/signTask/list">
                        <NavLink to="/signTask/list">签到列表</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/signTask/taskInfo">
                        <NavLink to="/signTask/taskInfo">每日任务情况</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/taskNotes/list">
                        <NavLink to="/taskNotes/list">任务备注</NavLink>
                    </Menu.Item>
                    <Menu.Item key="/operationRecords/list">
                        <NavLink to="/operationRecords/list">日常运营手册</NavLink>
                    </Menu.Item>
                </SubMenu>
            </Menu>
        );
    }
});

const Main = props => {
    if (user && window.location.href.indexOf('/client/machineCheck') < 0) {
        return (
            <Layout style={{padding: '0 0 0 0', background: '#fff', display: 'flex', flex: 1}}>
                <Sider collapsible width={200} style={{}} onCollapse={onCollapse}>
                    <SideMenu/>
                </Sider>
                <Layout>
                    <Content style={{padding: '0 24px', minHeight: 280, 'overflow-y': 'scroll', background: '#fff'}}>
                        <Switch>
                            <PrivateRoute exact path="/index" component={Index}/>
                            <PrivateRoute exact path="/partner/10" component={VPS}/>
                            <PrivateRoute exact path="/partner/11" component={Partner}/>
                            <PrivateRoute exact path="/assist/40" component={UaList}/>
                            <PrivateRoute exact path="/assist/41" component={DeviceList}/>
                            <PrivateRoute exact path="/assist/outTaskCategoryManage" component={OutTaskCategoryList}/>
                            <PrivateRoute exact path="/assist/localResourceManage" component={LocalResourceList}/>
                            <PrivateRoute exact path="/assist/standardLine" component={StandardLineList} />
                            <PrivateRoute exact path="/assist/42" component={BrowserList}/>
                            <PrivateRoute exact path="/assist/43" component={BaselineList}/>
                            <PrivateRoute exact path="/assist/hostManage" component={HostList}/>
                            <PrivateRoute exact path="/assist/tecentConfigManage" component={TecentConfigList}/>
                            <PrivateRoute exact path="/assist/deviceIndex" component={DeviceIndex}/>
                            <PrivateRoute exact path="/assist/logCollect" component={LogCollect}/>
                            <PrivateRoute exact path="/statistics/task/:id" component={TaskStatistics}/>
                            <PrivateRoute exact path="/statistics/task/" component={TaskStatistics}/>
                            <PrivateRoute exact path="/statistics/51" component={PartnerStatistics}/>
                            <PrivateRoute exact path="/statistics/52" component={IPStatistics}/>
                            <PrivateRoute exact path="/monitor/60" component={ServerMonitor}/>
                            <PrivateRoute exact path="/monitor/61" component={VpsMonitor}/>
                            <PrivateRoute exact path="/monitor/62" component={OperatingMonitor}/>
                            <PrivateRoute exact path="/monitoringcode/query" component={thirdParty}/>
                            <PrivateRoute exact path="/user/list" component={UserList}/>
                            <PrivateRoute exact path="/user/edit" component={UserEdit}/>
                            <PrivateRoute exact path="/user/taskMessage" component={TaskMessage}/>
                            <PrivateRoute exact path="/task/tasklist" component={TaskList}/>
                            <PrivateRoute exact path="/task/todayStartTask" component={todayStartTask}/>
                            <PrivateRoute exact path="/user/userGroup" component={UserGroup}/>
                            <PrivateRoute exact path="/statistics/taskView" component={StatisticsView}/>
                            <PrivateRoute exact path="/statistics/report" component={Report}/>
                            <PrivateRoute exact path="/statistics/exportData" component={ExportData}/>
                            <PrivateRoute exact path="/statistics/newExportData" component={NewExportData}/>
                            <PrivateRoute exact path="/statistics/everydayExecInfo" component={EverydayExecInfo}/>
                            <PrivateRoute exact path="/statistics/agencyAnalysis" component={AgencyAnalysis}/>
                            <PrivateRoute exact path="/statistics/agentConnentData" component={AgentConnentData}/>
                            <PrivateRoute exact path="/statistics/widthAndConnect" component={widthAndConnect}/>
                            <PrivateRoute exact path="/statistics/proxyExecuteData" component={ProxyExecuteData}/>
                            <PrivateRoute exact path="/statistics/taskVolume" component={taskVolume}/>
                            <PrivateRoute exact path="/statistics/phoneDetail" component={phoneDetail}/>
                            <PrivateRoute exact path="/statistics/advertPositionData" component={advertPositionData}/>
                            <PrivateRoute exact path="/statistics/advertPositionCurve" component={advertPositionCurve}/>
                            <PrivateRoute exact path="/client/clientList" component={ClientList}/>
                            <PrivateRoute exact path="/client/commend" component={CommendList}/>
                            <PrivateRoute exact path="/client/scriptList" component={ScriptList}/>
                            <PrivateRoute exact path="/client/AppList" component={AppList}/>
                            <PrivateRoute exact path="/client/AccountList" component={AccountList}/>
                            <PrivateRoute exact path="/client/wxAccountList" component={wxAccountList}/>
                            <PrivateRoute exact path="/client/certificateList" component={CertificateList}/>
                            <PrivateRoute exact path="/client/advertPosition" component={AdvertPosition}/>
                            <PrivateRoute exact path="/file/fileList" component={FileList}/>
                            <PrivateRoute exact path="/monitor/discardList" component={DiscardList}/>
                            <PrivateRoute exact path="/monitor/localResourceRate" component={LocalResourceRate}/>
                            <PrivateRoute exact path="/monitor/agentManage" component={AgentManage}/>
                            <PrivateRoute exact path="/monitor/name" component={nameTest}/>
                            <PrivateRoute exact path="/monitor/taskExcuteData" component={taskExcuteData}/>
                            <PrivateRoute exact path="/monitor/taskIvt" component={taskIvt}/>
                            <PrivateRoute exact path="/signTask/list" component={signList}/>
                            <PrivateRoute exact path="/taskNotes/list" component={taskNotes}/>
                            <PrivateRoute exact path="/operationRecords/list" component={operationRecords}/>
                            <PrivateRoute exact path="/signTask/taskInfo" component={taskInfo}/>
                            <PrivateRoute exact path="/assist/clientManage" component={clientManage}/>
                            <Route component={NotFound}/>
                        </Switch>
                    </Content>
                    <Footer style={{textAlign: 'center'}}>
                        恒紫科技 ©2017 &nbsp;
                        <a href="https://beian.miit.gov.cn" target="_blank"
                           style={{textAlign: 'center'}}>京ICP备17061463号-1</a></Footer>
                </Layout>
            </Layout>
        );
    } else {
        if (window.location.href.indexOf('/client/machineCheck') > 0) {
            return (
                <Layout>
                    <PrivateRouteNoLogin exact path="/client/machineCheck" component={MachineCheck}/>
                    <Footer style={{textAlign: 'center'}}>恒紫科技 ©2017 &nbsp;
                        <a href="https://beian.miit.gov.cn" target="_blank"
                           style={{textAlign: 'center'}}>京ICP备17061463号-1</a> </Footer>
                </Layout>
            );
        } else {
            return (
                <Layout>
                    <Login style={{flex: 1}}/>
                    <Footer style={{textAlign: 'center'}}>
                        恒紫科技 ©2017 &nbsp;
                        <a href="https://beian.miit.gov.cn" target="_blank"
                           style={{textAlign: 'center'}}>京ICP备17061463号-1</a> </Footer>
                </Layout>
            );
        }
    }
};

export default class extends React.Component {
    componentDidMount() {
    }

    render() {
        return (
            <Provider store={store}>
                <Router>
                    <Layout style={{minHeight: '100vh'}}>
                        <Header>
                            <span style={{color: '#fff', fontSize: '16px'}}>渠道运营管理</span>
                            <Logo/>
                        </Header>
                        <Layout style={{padding: '0'}}>
                            <Content style={{display: 'flex', height: 'calc(100vh - 130px)'}}>
                                <Main/>
                            </Content>
                        </Layout>
                    </Layout>
                </Router>
            </Provider>
        );
    }
}

// const AuthButton = withRouter(({ history }) => (
//     fakeAuth.isAuthenticated ? (
//         <p>
//             已登录!
//              <Button onClick={() => {
//                 fakeAuth.signout(() => history.push('/login'))
//             }}>退出</Button>
//         </p>
//     ) :
//         (<p>未登录</p>)
// ))

// const PrivateRoute = ({ component: Component, ...rest }) => (
//     <Route {...rest}
//         render={props => (
//             fakeAuth.isAuthenticated ? (
//                 <Component {...props} />
//             ) : (
//                     <Redirect to={{
//                         pathname: '/login',
//                         state: { from: props.location }
//                     }} />
//                 )
//         )} />
// )



// WEBPACK FOOTER //
// ./routes.js